import {Grid, Typography, Stack, Box} from '@mui/material';
import MainCard from "../../../Components/MainCard";
import SelectOrganisationPlanUpdate
    from "../../../assets/images/getting-started/subscribinginfo/SelectOrganisationUpdate.png";
import MultiEditProfile from "../../../assets/images/getting-started/subscribinginfo/MultiEditProfile.png";
import XeroIntegrations from "../../../assets/images/getting-started/subscribinginfo/XeroIntegrations.png";
import XeroIntegrationSignIn from "../../../assets/images/getting-started/subscribinginfo/XeroIntegrationSignin.png";
import XeroOrgSelect from "../../../assets/images/getting-started/subscribinginfo/XeroOrgSelect.png";

function XeroOrganisations(){
    return (
        <MainCard>
            <Stack spacing={2.5}>
                <Typography variant="h4">
                    Connecting Xero Organisations
                </Typography>
                <Typography variant="body1">
                Adding multiple Xero Organisations to your subscription is only available on the Multi Organisation Plan.
                    To connect additional Xero Organisations to your plan please follow the instructions below:
                </Typography>
                <Typography variant="h6">
                Adding Xero Organisations
            </Typography>
            <Typography variant="body1">
                Only the subscription owner (the user that purchased the plan) is able to add additional Xero Organisations
                to the plan. This is to ensure a Plan can only access Xero Organisations that it is meant to have access to.
            </Typography>
            <Typography variant="body1">
                To add additional Xero Organisations please follow the steps below:
            </Typography>
            <Typography variant="body1">
                1. Select the Xero Organisation you would like to add additional Users to.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={SelectOrganisationPlanUpdate} alt="Select Subscription" />
                </Box>
            </Typography>
            <Typography variant="body1">
                2. Navigate to the Edit Profile page.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={MultiEditProfile} alt="Multi Organisation Edit Profile" />
                </Box>
            </Typography>
            <Typography variant="body1">
                3. Click the Xero Integrations tab.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={XeroIntegrations} alt="Xero Integrations" />
                </Box>
            </Typography>
            <Typography variant="body1">
                4. Click the Xero Sign In button. NOTE: Only subscription owner can add additional Xero Organisations.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={XeroIntegrationSignIn} alt="Xero Integrations Sign In" />
                </Box>
            </Typography>
            <Typography variant="body1">
                5. Select the Xero Organisations you would like to connect with. Once selection is complete click on Continue.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={XeroOrgSelect} alt="Xero Organisation Select" />
                </Box>
            </Typography>
            </Stack>
        </MainCard>
    )
}

export default XeroOrganisations;